import {Entity} from '../../../core/commons/entity';
import {DynField} from '../meta/dyn-field';

export abstract class DynFieldData implements Entity {

    public id: number;
    public type: string;
    private field: DynField;
    protected value: any;
    private observations: string;

    public constructor() {
    }

    public getId(): number {
        return this.id;
    }

    public setId(value: number) {
        this.id = value;
    }

    public getType(): string {
        return this.type;
    }

    public setType(type: string): void {
        this.type = type;
    }

    public getField(): DynField {
        return this.field;
    }

    public setField(value: DynField) {
        this.field = value;
    }

    public getValue(): any {
        return this.value;
    }

    public setValue(value: any): void {
        this.value = value;
    }

    public getObservations(): string {
        return this.observations;
    }

    public setObservations(value: string) {
        this.observations = value;
    }

    public getTypedValue(): any {
        return this.getField().getValue(this);
    }

    public setTypedValue(value: any) {
        this.value = this.getField().setValue(this, value);
    }

    public getValueAsString() {
        let value = this.getField().getValueAsString(this);
        if (value == '31/12/1969') value = null;
        return value;
    }

    public getAlignment() {
        switch (this.getField().getAlignment()) {
            case 'LEFT': return 'align-left';
            case 'RIGHT': return 'align-right';
            case 'JUSTIFIED': return 'align-justify';
            case 'CENTER': return 'align-center';
            default: return 'align-left';
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/forms/domain/data/dyn-field-data.ts